<app-card appVisible [visible$]="visible$">
  <h5 class="text-center"><i class="bi" [class]="icon"></i>{{ title }}</h5>
  <div class="scroll-div d-flex flex-column h-100">
    <table class="table table-sm m-0">
      @if ((data$ | async) && !loading && !error) {
        @for (item of (data$ | async)?.values; track item.label) {
          <tr>
            <td class="text-small text-body-secondary p-0">
              {{ item.label }}
            </td>
          </tr>
          <tr>
            <td class="d-flex flex-column">
              <div class="d-flex justify-content-between gap-2 p-0">
                <div class="progress flex-grow-1 my-1">
                  <div
                    class="progress-bar"
                    [style.width]="item.percentage + '%'"
                    [style.background-color]="getColor($index)"
                  >
                    @if (item.percentage >= 20) {
                      {{ item.percentage | appNumber }}%
                    }
                  </div>
                  @if (item.percentage < 20) {
                    <div class="ps-2">{{ item.percentage | appNumber }}%</div>
                  }
                </div>
              </div>
            </td>
            <td class="fit text-end align-bottom text-nowrap">
              <span class="text-body-secondary text-small fw-bold ps-1">{{ item.value | appNumber }} {{ unit }}</span>
            </td>
          </tr>
        }
      }
      @if (loading) {
        @for (i of [50, 30, 10, 5, 1]; track $index) {
          <tr class="placeholder-glow">
            <td class="placeholder text-small p-0"></td>
          </tr>
          <tr>
            <td>
              <div class="d-flex justify-content-between gap-2 p-0">
                <div class="placeholder-glow progress flex-grow-1 my-1">
                  <div
                    class="progress-bar placeholder"
                    [style.width]="i + '%'"
                    [style.background-color]="'#' + ($index + 2).toString().repeat(3)"
                  ></div>
                </div>
              </div>
            </td>
            <td class="fit text-small text-end">
              <div class="placeholder-glow">
                <span class="placeholder"></span>
              </div>
            </td>
          </tr>
        }
      }
    </table>
    @if (!loading && empty) {
      <app-message>Geen data beschikbaar</app-message>
    } @else if (error) {
      <app-error-message [error]="error"></app-error-message>
    }
  </div>
</app-card>
